import { Box, MenuItem as MuiMenuItem } from '@mui/material'
import { omit } from 'lodash'
import { RxCheck } from 'react-icons/rx'
import { tss } from 'tss-react/mui'
import { Chip } from '../../chip/Chip'
import { MenuItemProps } from '../types'
import { getSelectedCheckmarkPrimitives, menuItemPrimitives } from './primitives'

const useStyles = tss.withParams<{ isSelected: boolean }>().create(({ isSelected }) => {
  return {
    menu: menuItemPrimitives,
    checkMark: getSelectedCheckmarkPrimitives(isSelected),
  }
})

export const ChipMenuItem = ({
  label,
  className,
  selected,
  ...rest
}: Omit<MenuItemProps, 'variant'>) => {
  const isSelected = selected || false
  const { cx, classes } = useStyles({ isSelected })
  const menuItemProps = omit(rest, ['showCheckmark'])
  return (
    <MuiMenuItem className={cx(classes.menu, className)} selected={selected} {...menuItemProps}>
      <Box className={classes.checkMark}>
        <RxCheck size="14px" />
      </Box>
      <Chip color={'gray'} isRounded={false} label={label} variant={'solid'}></Chip>
    </MuiMenuItem>
  )
}
